import React, { useState } from "react"
import { format } from "date-fns"
import { ja, enUS } from "date-fns/locale"
import { githubRender } from "~utils/rehype-render"
import {
  FiExternalLink,
  FiTag,
  FiStar,
  FiCalendar,
  FiChevronsDown,
  FiChevronsUp,
  FiZap,
} from "react-icons/fi"
import { OutboundLink } from "gatsby-plugin-gtag"

import * as style from "./Entries.module.scss"

const locales = {
  en: enUS,
  jp: ja,
}

const Entry = ({ entry, engine, microcopy }) => {
  const id = engine.entryId(entry)
  const { collapsed } = engine.state
  const isNew = engine.isNew(entry)

  const [display, setDisplay] = useState(false)

  return (
    <div className={style.entry} data-is-new={isNew}>
      <header id={id}>
        <span data-new-label>
          <FiZap />
          {microcopy.text("changelog.unread", "unread")}
        </span>
        <time dateTime={entry.frontmatter.published_at}>
          <FiCalendar />
          {format(
            Date.parse(entry.frontmatter.published_at.replace("-", "/")),
            "MMM do, Y",
            { locale: locales[microcopy.code] },
          )}
        </time>
        <a href={entry.path}>{githubRender(entry.titleAst)}</a>
      </header>
      <div data-labels>
        {entry.frontmatter.is_new_feature && (
          <span
            data-type="new"
            onClick={engine.toggleFilter("is_new_feature", true)}
            data-selected={engine.hasFilter("is_new_feature", true)}
          >
            <FiStar />
            {' '}
            {microcopy.text("changelog.levels.short.is_new_feature")}
          </span>
        )}
        {entry.frontmatter.is_impactful && (
          <span
            data-type="impactful"
            onClick={engine.toggleFilter("is_impactful", true)}
            data-selected={engine.hasFilter("is_impactful", true)}
          >
            <FiStar />
            {' '}
            {microcopy.text("changelog.levels.short.is_impactful")}
          </span>
        )}
        {entry.frontmatter.applies_to.map((label, index) => (
          <span
            key={index}
            data-type={label}
            onClick={engine.toggleFilter("label", label)}
            data-selected={engine.hasFilter("label", label)}
          >
            <FiTag />
            {' '}
            {microcopy.text(`changelog.labels.${label}`, label)}
          </span>
        ))}
        {entry.frontmatter.release_source_url && (
          <OutboundLink
            href={entry.frontmatter.release_source_url}
            target="_none"
            className={style.externalLink}
          >
            <FiExternalLink />
            {' '}
            GitHub
          </OutboundLink>
        )}
      </div>
      {!(collapsed && entry.frontmatter.collapse && !display) && (
        <div data-body>{githubRender(entry.htmlAst)}</div>
      )}
      {collapsed
        && entry.frontmatter.collapse
        && !display
        && entry.frontmatter.show_excerpt && (
          <div data-excerpt data-collapsed={collapsed}>
            {githubRender(entry.excerptAst)}
          </div>
      )}
      {collapsed && entry.frontmatter.collapse && (
        <div
          data-expand
          onClick={() => setDisplay((s) => !s)}
          data-display={display}
        >
          <span>
            {display ? (
              <FiChevronsUp />
            ) : (
              <>
                <FiChevronsDown />
                {microcopy.text("messages.read_more")}
              </>
            )}
          </span>
        </div>
      )}
    </div>
  )
}

export default Entry
